export default __webpack_public_path__ + "static/media/single-project-page-02-img5.f412397e.jpg";